export default __webpack_public_path__ + "static/media/dark-theme-example.ae1c5a87.png";